export const APP_STORE_LINK = 'itms-services://?action=download-manifest&url=https://iborscht.github.io/manifest.plist';
export const GOOGLE_STORE_LINK = 'https://drive.google.com/file/d/13peY-VNta22m2Eez9wjhmeH-lyuI6VYG/view?usp=sharing';
